export default "/images/corner-left-up.svg?2b4b25188c56155a4b24f0156090482d";